import Vue from "vue";
import utils from "../common/utils";

export default Vue.extend({
  template: `<span class="h-100 d-flx aic jcc">
    <b-button class="h24 d-flx aic jcc" style="border-radius: 5px;" :style="computedStyle" @click="funcClick" :disabled="disabled">
      <i :class="iconClass" v-if="iconYn"></i>{{ btnName }}
    </b-button>
  </span>`,
  data() {
    return {
      btnName: null,
      iconYn: false,
      iconClass: null,
      bintStyle: {
        backgrounColor: "#ff8c00",
        borderColor: "#ff8c00",
        color: "#fff",
      },
      disabled: false,
    };
  },
  computed: {
    computedStyle() {
      return {
        ...this.bintStyle,
        cursor: this.disabled ? 'not-allowed' : 'pointer'
      };
    }
  },
  created() {
    this.initBtn();
  },
  methods: {
    initBtn() {
      this.btnName = utils.chkNull(
        this.params.colDef.cellRendererParams.btnText
      );
      this.iconYn = utils.chkNull(
        this.params.colDef.cellRendererParams.iconYn,
        false
      );
      this.iconClass = utils.chkNull(
        this.params.colDef.cellRendererParams.iconClass
      );
      this.bintStyle.backgroundColor =
        this.params.colDef.cellRendererParams.backgroundColor;
      this.bintStyle.borderColor =
        this.params.colDef.cellRendererParams.borderColor;
      this.bintStyle.color = this.params.colDef.cellRendererParams.color;
      if (
        utils.chkNull(this.params.colDef.cellRendererParams.disableCaseCol) !==
        null
      ) {
        if (
          this.params.colDef.cellRendererParams.disableCaseValue !== undefined
        ) {
          this.disabled =
            utils.chkNull(
              this.params.colDef.cellRendererParams.disableCaseValue
            ) ===
            utils.chkNull(
              this.params.data[
                this.params.colDef.cellRendererParams.disableCaseCol
              ]
            );
        }
        if (
          this.params.colDef.cellRendererParams.disableCaseValues !== undefined
        ) {
          this.disabled = utils
            .chkNull(this.params.colDef.cellRendererParams.disableCaseValues)
            .includes(
              utils.chkNull(
                this.params.data[
                  this.params.colDef.cellRendererParams.disableCaseCol
                ]
              )
            );
        }
      }
    },
    funcClick() {
      if (this.params.colDef.cellRendererParams.onClick) {
        this.params.colDef.cellRendererParams.onClick(this.params.data);
      } else if (this.params.colDef.cellRendererParams.evtBus) {
        this.params.colDef.cellRendererParams.evtBus.$emit(
          this.params.colDef.cellRendererParams.emitEvtName,
          this.params.data
        );
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/common/cellBtnRenderer.js